import { render, staticRenderFns } from "./vendorOrdersMainView.vue?vue&type=template&id=6de9fa82&scoped=true"
import script from "./vendorOrdersMainView.vue?vue&type=script&lang=js"
export * from "./vendorOrdersMainView.vue?vue&type=script&lang=js"
import style0 from "./vendorOrdersMainView.vue?vue&type=style&index=0&id=6de9fa82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de9fa82",
  null
  
)

export default component.exports